import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    cryptogram: null,
    cryptogramList: null,
  },
  mutations: {
    setCryptogramList(state, response) {
      state.cryptogramList = response;
    },
    setCryptogram(state, cryptogram) {
      state.cryptogram = cryptogram;
    },
  },
  actions: {
    getCryptogram({ commit }, id) {
      PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setCryptogram', response);
        });
    },
    getCryptogramList({ commit }, params) {
      PuzzleService.getPuzzles(params)
        .then(response => {
          commit('setCryptogramList', response);
        });
    },
    setCryptogram({ commit }, model) {
      commit('setCryptogram', model);
    },
  },
};
